export default "__VITE_ASSET__9d379ced__"